var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchForm'),_c('PropertiesCp',{attrs:{"immobili":_vm.immobili,"show":'true'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }